/* Atelier Theme – JavaScript */
(function () {
  'use strict';

  /* ---------- Header: kompakt beim Scrollen ---------- */
  const header = document.querySelector('[data-header]');
  function setHeaderBottom() {
    if (!header) return;
    const r = header.getBoundingClientRect();
    document.documentElement.style.setProperty('--header-bottom', Math.max(0, r.bottom) + 'px');
  }
  if (header) {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        if (window.scrollY > 120) header.classList.add('is-scrolled');
        else if (window.scrollY < 10) header.classList.remove('is-scrolled');
        setHeaderBottom();
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', setHeaderBottom);
    onScroll();
    const drawer = header.querySelector('.menu-drawer');
    if (drawer) {
      drawer.addEventListener('toggle', () => {
        setHeaderBottom();
        document.body.style.overflow = drawer.open ? 'hidden' : '';
      });
    }
  }

  /* ---------- Sanftes Einblenden ---------- */
  const REVEAL = '.section-header, .card, .artwork, .split__media, .split__content, .quote, .newsletter, .rich-text, .timeline__item, .collection-tile, .article-card';
  function initReveal(root) {
    const els = (root || document).querySelectorAll(REVEAL);
    if (!('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) {
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach((el, i) => {
      if (el.closest('.hero') || el.closest('.product')) return;
      el.classList.add('reveal');
      el.style.transitionDelay = (el.matches('.card, .artwork') ? (i % 4) * 90 : 0) + 'ms';
      io.observe(el);
    });
  }
  initReveal();

  /* ---------- Lightbox ---------- */
  const lightbox = document.getElementById('Lightbox');
  let lbItems = [];
  let lbIndex = 0;

  function lbShow(i) {
    if (!lbItems.length) return;
    lbIndex = (i + lbItems.length) % lbItems.length;
    const el = lbItems[lbIndex];
    const img = lightbox.querySelector('.lightbox__img');
    const cap = lightbox.querySelector('.lightbox__caption');
    img.src = el.dataset.full;
    img.alt = el.dataset.alt || '';
    cap.innerHTML = '';
    if (el.dataset.title) {
      const s = document.createElement('strong');
      s.textContent = el.dataset.title;
      cap.appendChild(s);
    }
    if (el.dataset.meta) cap.appendChild(document.createTextNode(el.dataset.meta));
    if (el.dataset.text) {
      const p = document.createElement('p');
      p.className = 'lightbox__text';
      p.textContent = el.dataset.text;
      cap.appendChild(p);
    }
    if (el.dataset.link) {
      const a = document.createElement('a');
      a.className = 'lightbox__link';
      a.href = el.dataset.link;
      a.textContent = el.dataset.linkLabel || 'Im Shop ansehen';
      cap.appendChild(a);
    }
    lightbox.classList.toggle('lightbox--text', !!el.dataset.text);
    const fig = lightbox.querySelector('.lightbox__figure');
    if (fig) fig.scrollTop = 0;
    const multi = lbItems.length > 1;
    lightbox.querySelectorAll('.lightbox__nav').forEach((b) => (b.style.visibility = multi ? 'visible' : 'hidden'));
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-lightbox]');
    if (!trigger || !lightbox) return;
    e.preventDefault();
    const group = trigger.dataset.lightbox;
    lbItems = Array.from(document.querySelectorAll('[data-lightbox="' + group + '"]')).filter(
      (el) => !el.closest('.artwork[hidden]')
    );
    lightbox.showModal();
    lbShow(lbItems.indexOf(trigger));
  });

  if (lightbox) {
    lightbox.querySelector('[data-lightbox-close]').addEventListener('click', () => lightbox.close());
    lightbox.querySelector('[data-lightbox-prev]').addEventListener('click', () => lbShow(lbIndex - 1));
    lightbox.querySelector('[data-lightbox-next]').addEventListener('click', () => lbShow(lbIndex + 1));
    lightbox.addEventListener('click', (e) => {
      if (e.target === lightbox || e.target.classList.contains('lightbox__figure')) lightbox.close();
    });
    lightbox.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') lbShow(lbIndex - 1);
      if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
    });
  }

  /* ---------- Galerie-Filter ---------- */
  document.querySelectorAll('[data-gallery-filter]').forEach((bar) => {
    const gallery = document.getElementById(bar.dataset.galleryFilter);
    if (!gallery) return;
    bar.addEventListener('click', (e) => {
      const btn = e.target.closest('button[data-filter]');
      if (!btn) return;
      bar.querySelectorAll('button').forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
      const f = btn.dataset.filter;
      gallery.querySelectorAll('.artwork').forEach((item) => {
        const cats = (item.dataset.category || '').split('|');
        item.hidden = !(f === '*' || cats.includes(f));
      });
    });
  });

  /* ---------- Menge +/- ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty]');
    if (!btn) return;
    const input = btn.parentElement.querySelector('input');
    const min = parseInt(input.min || '0', 10);
    const next = Math.max(min, (parseInt(input.value, 10) || 0) + (btn.dataset.qty === 'plus' ? 1 : -1));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Produkt: Medien ---------- */
  document.querySelectorAll('[data-product-media]').forEach((wrap) => {
    wrap.addEventListener('click', (e) => {
      const thumb = e.target.closest('[data-thumb]');
      if (!thumb) return;
      showMedia(wrap, thumb.dataset.thumb);
    });
  });

  function showMedia(wrap, id) {
    wrap.querySelectorAll('.product__media-item').forEach((m) => (m.hidden = m.dataset.mediaId !== String(id)));
    wrap.querySelectorAll('[data-thumb]').forEach((t) =>
      t.setAttribute('aria-current', t.dataset.thumb === String(id) ? 'true' : 'false')
    );
  }

  /* ---------- Produkt: Varianten ---------- */
  document.querySelectorAll('[data-product]').forEach((root) => {
    const dataEl = root.querySelector('[data-variants-json]');
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const idInput = root.querySelector('input[name="id"]');
    const priceEl = root.querySelector('[data-price]');
    const addBtn = root.querySelector('[data-add-button]');
    const mediaWrap = document.querySelector('[data-product-media]');

    function selected() {
      return Array.from(root.querySelectorAll('.option-group')).map(
        (g) => (g.querySelector('input:checked') || {}).value
      );
    }

    function update() {
      const opts = selected();
      const v = variants.find((x) => x.options.every((o, i) => o === opts[i]));

      // Verfügbarkeit der Optionswerte markieren
      root.querySelectorAll('.option-group').forEach((g, gi) => {
        g.querySelectorAll('input').forEach((inp) => {
          const test = opts.slice();
          test[gi] = inp.value;
          const ok = variants.some((x) => x.available && x.options.every((o, i) => o === test[i]));
          const label = g.querySelector('label[for="' + inp.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !ok);
        });
      });

      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = window.theme.strings.unavailable; }
        return;
      }
      idInput.value = v.id;
      if (priceEl) {
        priceEl.classList.toggle('price--on-sale', !!v.compare);
        priceEl.innerHTML =
          '<span class="price__current">' + v.price + '</span>' +
          (v.compare ? '<s class="price__compare">' + v.compare + '</s>' : '');
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? window.theme.strings.addToCart : window.theme.strings.soldOut;
      }
      if (v.media && mediaWrap) showMedia(mediaWrap, v.media);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    root.addEventListener('change', (e) => {
      if (e.target.closest('.option-group')) update();
    });
  });

  /* ---------- AJAX: In den Warenkorb ---------- */
  const toast = document.getElementById('CartToast');
  let toastTimer;

  function showToast(text) {
    if (!toast) return;
    toast.querySelector('.toast__text').textContent = text;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => (toast.hidden = true), 5000);
  }

  function updateCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => {
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
          el.dataset.count = cart.item_count;
        });
      });
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form.product-form');
    if (!form || !window.fetch) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    fetch(window.theme.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then((r) => r.json().then((d) => ({ ok: r.ok, d })))
      .then(({ ok, d }) => {
        if (!ok) throw new Error(d.description || d.message);
        showToast('„' + d.product_title + '“ ' + window.theme.strings.added);
        updateCount();
      })
      .catch((err) => showToast(err.message || window.theme.strings.error))
      .finally(() => btn && btn.removeAttribute('aria-busy'));
  });

  /* ---------- Sortierung (Kollektion) ---------- */
  document.querySelectorAll('[data-sort-select]').forEach((sel) => {
    sel.addEventListener('change', () => sel.form.submit());
  });

  /* ---------- Warenkorb: Menge automatisch aktualisieren ---------- */
  const cartForm = document.querySelector('form[data-cart-form]');
  if (cartForm) {
    let t;
    cartForm.addEventListener('change', (e) => {
      if (!e.target.matches('input[name="updates[]"]')) return;
      clearTimeout(t);
      t = setTimeout(() => cartForm.submit(), 600);
    });
  }
})();
